import PropTypes from 'prop-types';
// import { ESTADOS, PROCESOS_ESPECIFICOS, TIPO_MONITOREOS } from 'constants/nombresCatalogos';
import { TERMINADO } from 'constants/downloadStatus';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './TablaGeneracionEnlaces.scss';
import { Table, Button, Input, SelectTamanoPagina, Tooltip } from 'components';
import { DatePicker, message, Col } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { getAllLinks } from 'actions/downloads.actions';
import { downloadExcelEnlaces } from 'actions/files.actions';
import { base64toBlob } from 'utils/file';
import { selectMenuState } from 'selectors/auth.selector';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import {
  NOMBRE_MENU_DESCARGAS,
  NOMBRE_MENU_PERMISO_DESCARGAR,
  NOMBRE_SUBMENU_GEN_ENLACES
} from 'constants/menuNombres';
import { selectLinksState } from 'selectors/downloads.selector';
import { ReactComponent as LinkPlus } from 'assets/images/Enlaces/link_plus.svg';
import iconPdf from 'assets/images/SelectorDescargaImage/Icono_PDF.svg';
import iconExcel from 'assets/images/Excel_.svg';
import moment from 'moment';
import {
  DATE_FORMAT_COLUMN_TABLE,
  DATE_FORMAT_DATE_PICKER,
  DATE_FORMAT_IN_TEXT
} from 'constants/dateFormat';
import { useDebounce } from 'hooks/useDebounce';
import dayjs from 'dayjs';
import { filterList } from 'utils/filterList';
import Modal from 'components/Modal/Modal';

const DEBOUNCE_TIME_FILTER = 2000;

export const TablaGeneracionEnlaces = ({ mainFilters }) => {
  const filtersRef = useRef({});
  const [filters, setFilters] = useState({});
  const menu = useSelector(selectMenuState);
  // eslint-disable-next-line no-unused-vars
  const [messageApi, contextHolder] = message.useMessage();
  const [isVisibleEnlaces, setIsVisibleEnlaces] = useState(false);
  const [urlTestigos, setUrlTestigos] = useState('');
  const [urlSabanas, setUrlSabanas] = useState('');
  const [fechaVigencia, setFechaVigencia] = useState('');
  const [downloadingExcel, setDownloadingExcel] = useState(false);

  const showTotal = (total, range) => {
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };
  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    showTotal
  });

  const applyFilter = useDebounce((fields) => setFilters(fields), DEBOUNCE_TIME_FILTER);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllLinks());
  }, []);

  const { loading, data } = useSelector(selectLinksState);

  const padId = (id) => {
    if (id !== undefined) {
      return id.toString().padStart(8, '0');
    }
    return null;
  };

  const handleChangeFilter = ({ target }) => {
    const { value, name } = target;
    filtersRef.current[name] = value;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeInitDateFilter = (date) => {
    filtersRef.current.fechaInicioPeticionFormat = date;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeEndDateFilter = (date) => {
    filtersRef.current.fechaFinPeticionFormat = date;
    applyFilter({ ...filtersRef.current });
  };

  const handleDownloadFile = async (urlPdf, urlExcel) => {
    setIsVisibleEnlaces(true);
    setUrlTestigos(urlPdf);
    setUrlSabanas(urlExcel);
  };

  const filter = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        id={columnName}
        placeholder="Filtrar"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilter}
      />
    </label>
  );

  const filterInitDate = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Filtrar"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeInitDateFilter}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const filterEndDate = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Filtrar"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeEndDateFilter}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const renderActions = (value, row) => (
    <div className="actions-container">
      {getMenuPermissions(
        menu,
        NOMBRE_MENU_DESCARGAS,
        NOMBRE_SUBMENU_GEN_ENLACES,
        NOMBRE_MENU_PERMISO_DESCARGAR
      ) &&
        row.estatusDescripcion === TERMINADO.label &&
        row.estaVigente === 1 && (
          <Tooltip title="Mostrar enlaces" class="tooltip-acciones">
            <Button
              type="primary"
              onClick={() => {
                const fecha = moment(row.vigencia, 'YYYYMMDD').format(DATE_FORMAT_IN_TEXT);
                setFechaVigencia(fecha);
                handleDownloadFile(row.urlTestigos, row.urlSabana);
              }}
              icon={<LinkPlus />}
              ghost
            />
          </Tooltip>
        )}
    </div>
  );

  const handleCloseEnlaces = () => {
    setIsVisibleEnlaces(false);
  };

  const columns = [
    {
      title: 'ID del enlace:',
      dataIndex: 'idEnlaces',
      width: '10%',
      key: 'idEnlaces',
      render: (text) => padId(text)
    },
    {
      title: 'Tipo de monitoreo',
      dataIndex: 'tipoMonitoreo',
      width: '10%',
      key: 'tipoMonitoreo'
    },
    {
      title: 'Descripción:',
      dataIndex: 'descripcion',
      width: '25%',
      key: 'descripcion'
    },
    {
      title: filterInitDate('fechaInicioPeticionFormat', 'Solicitud:'),
      dataIndex: 'fechaInicioPeticionFormat',
      render: (d) => (d ? d.format(DATE_FORMAT_COLUMN_TABLE) : ''),
      width: '15%'
    },
    {
      title: filterEndDate('fechaFinPeticionFormat', 'Entrega:'),
      dataIndex: 'fechaFinPeticionFormat',
      render: (d) => (d ? d.format(DATE_FORMAT_COLUMN_TABLE) : ''),
      width: '15%'
    },
    {
      title: filter('estatusDescripcion', 'Estatus:'),
      dataIndex: 'estatusDescripcion',
      key: 'estatusDescripcion',
      align: 'center',
      width: '15%'
    },
    {
      title: 'Vigencia del enlace:',
      dataIndex: 'fechaVigenciaFormat',
      render: (d) => (d ? d.format(DATE_FORMAT_COLUMN_TABLE) : ''),
      width: '25%'
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      align: 'center',
      width: '5%',
      key: 'actions',
      render: renderActions
    }
  ];

  const handleChangePageSize = (pageSize) => {
    setPagination((prevPagination) => ({ ...prevPagination, pageSize }));
  };

  const obtenerFechaInicio = (fecha) => {
    return dayjs(new Date(fecha.$y, fecha.$M, fecha.$D, 0, 0, 0));
  };

  const obtenerFechaFin = (fecha) => {
    return dayjs(new Date(fecha.$y, fecha.$M, fecha.$D, 23, 59, 59));
  };

  const filteredList = useMemo(() => {
    const { idEnlaces, tipoMonitoreo, estatus, fechaInicio, fechaFinal } = mainFilters;
    const filteredData = data.filter((row) => {
      if (idEnlaces && row.idEnlaces !== Number(idEnlaces)) return false;
      if (tipoMonitoreo && row.idTipoMonitoreo !== tipoMonitoreo) return false;
      if (estatus !== undefined && estatus !== row.estatus) return false;
      if (fechaFinal && obtenerFechaFin(fechaFinal) <= row.fechaFinPeticionFormat) return false;
      if (fechaInicio && obtenerFechaInicio(fechaInicio) >= row.fechaFinPeticionFormat)
        return false;
      return true;
    });
    return filteredData;
  }, [data, mainFilters]);

  const dataList = useMemo(() => {
    return filterList(filteredList, filters);
  }, [filteredList, filters]);

  const handleDownloadExcel = async () => {
    setDownloadingExcel(true);
    const { success, response } = await dispatch(downloadExcelEnlaces({ enlaces: dataList }));
    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
          setDownloadingExcel(false);
        }
      }
    }
    setDownloadingExcel(false);
  };

  return (
    <div className="tabla-monitoreo">
      <div className="table-header">
        <div>
          <SelectTamanoPagina
            value={pagination.pageSize}
            onChange={handleChangePageSize}
            disableBottomExcel={downloadingExcel}
            onClick={handleDownloadExcel}
          />
        </div>
      </div>
      {contextHolder}
      <Table
        bordered={false}
        columns={columns}
        dataSource={dataList}
        pagination={pagination}
        loading={loading}
      />
      <Modal
        title="Enlaces"
        visible={isVisibleEnlaces}
        width="60em"
        onCancel={handleCloseEnlaces}
        footer={null}
        cancelButtonProps={{ style: { display: 'none' } }}
        style={{ padding: '35px 0px 30px 30px' }}>
        <div className="modalEnlaces">
          <div className="links-container" style={{ justify: 'center', align: 'center' }}>
            <div className="message-label">
              <span
                style={{
                  fontSize: '13px',
                  width: '30rem',
                  height: '1.6rem',
                  align: 'center',
                  borderRadius: '0px 10px 10px 0px',
                  backgroundColor: 'rgba(101, 19, 152, 0.178)',
                  color: 'rgb(16, 11, 122)',
                  padding: '3px'
                }}>
                <InfoCircleOutlined style={{ color: '#c12b7d', marginRight: '0.5rem' }} />
                <b>¡Recuerda!</b> los enlaces estarán activos hasta el <b>{fechaVigencia}</b>,
                posterior a esta fecha, genera uno nuevo.&nbsp;&nbsp;
              </span>
            </div>
            <div style={{ padding: '10px' }}>
              <Col
                className="link-item"
                style={{
                  margin: '1em 0',
                  marginLeft: '20em',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                <img src={iconPdf} alt="" style={{ width: '20px' }} />
                <span style={{ fontWeight: '600' }}>&nbsp;&nbsp;Testigos:</span>
                <br />
              </Col>
              <Col span={24}>
                <a
                  href={urlTestigos}
                  target="_blank"
                  className="custom-link"
                  rel="noopener noreferrer"
                  style={{ fontSize: '13px', color: '#9e21cf', textDecoration: 'underline' }}>
                  {urlTestigos}
                </a>
              </Col>
              <br />
              <Col
                className="link-item"
                style={{
                  margin: '1em 0',
                  marginLeft: '20em',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                <img src={iconExcel} alt="" style={{ width: '20px' }} />
                <span style={{ fontWeight: '600' }}>&nbsp;&nbsp;Sábanas:</span>
                <br />
              </Col>
              <Col span={24}>
                <a
                  href={urlSabanas}
                  target="_blank"
                  className="custom-link"
                  rel="noopener noreferrer"
                  style={{ fontSize: '13px', color: '#9e21cf', textDecoration: 'underline' }}>
                  {urlSabanas}
                </a>
              </Col>
              <br />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

TablaGeneracionEnlaces.propTypes = {
  mainFilters: PropTypes.shape({
    fechaFinal: PropTypes.shape({}),
    fechaInicio: PropTypes.shape({}),
    idEnlaces: PropTypes.string,
    tipoMonitoreo: PropTypes.number,
    estatus: PropTypes.number
  }).isRequired
};
